$('.c-ancla-footer__link').on('click',function(){
    window.scrollTo({ top: 0});
    const target = document.querySelector('body');
    target.setAttribute('tabindex', '-1');
    target.focus();
});
